import React from 'react';

import { SafeAreaView, StyleSheet } from 'react-native';

import { LayoutContainer } from 'components/layout/styled';
import LoadingAnimation from 'components/loading-animation';
import { Table } from 'components/table';
import { Box } from 'components/ui';
import { spacing } from 'styles/constants';
import { isNative } from 'utils/environment';
import { ITable } from 'utils/table';

import { TransactionTable, TransactionTableRow } from './types';

const Spinner = () => (
  <LayoutContainer>
    <Box style={styles.spinner}>
      <LoadingAnimation />
    </Box>
  </LayoutContainer>
);

const styles = StyleSheet.create({
  spinner: {
    padding: spacing.$2,
  },
});

export const HistoryLazyTableList = ({
  tables,
  visibleTransactions,
  handleOnPressRow,
  loadingMore,
}: {
  tables: TransactionTable[];
  visibleTransactions?: number;
  handleOnPressRow: (row: TransactionTableRow | Partial<TransactionTableRow>) => void;
  loadingMore?: boolean;
}) => {
  const renderItem = ({
    item,
    index,
  }: {
    item: ITable<Partial<TransactionTableRow>>;
    index: number;
  }) => (
    <Table<TransactionTableRow>
      key={`historyTable.${index}`}
      table={item}
      onPressRow={handleOnPressRow}
      marginTop="$4"
    />
  );

  // Lazy Loading only for Native...
  if (isNative && visibleTransactions) {
    return (
      <SafeAreaView style={{ flex: 1 }}>
        {tables.slice(0, visibleTransactions).map((item, index) => renderItem({ item, index }))}
        {loadingMore && <Spinner />}
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={{ flex: 1 }}>
      {tables.map((item, index) => renderItem({ item, index }))}
    </SafeAreaView>
  );
};
